module.exports = __webpack_public_path__ + "static/media/trial_plan_icon.2bc8997b.svg";